import(/* webpackMode: "eager" */ "/vercel/path0/src/app/shipping-policy/page.tsx");
